import clsx from "clsx";
import SimilarListing from "components/elements/similarListing";
import { InsightService } from "lib/apis/entity/insight";
import { useOwnTranslate } from "lib/hooks/useOwnTranslate";
import { useState } from "react";
import useHPIDetail from "../hooks/useHPIDetail";


type ListingType = "BUY" | "RENT";

const HousePricesSimilarListing = () => {
  const { t } = useOwnTranslate('global');
  const [listingType, setListingType] = useState<ListingType>('BUY');
  const { seo, decode } = useHPIDetail({city:undefined,region:undefined});
  const { data, isLoading, isError, isFetched } =
    InsightService.HpiSimilarListing.useHpiSimilarListing({
      listingType,
      ...(decode?.city && {
        city: decode.city,
      }),
      ...(decode?.region && {
        region: Number(decode.region)
      }),
    });
  const { result } = { ...data?.data }

  return (
    <>
      <div className="mt-12">
        <h2 className="mb-4 lg:text-display-sm text-display-xs font-semiBold lg:mb-6">
          {seo?.seo.title}
        </h2>
        <SimilarListing
          content={result || []}
          isLoading={isLoading}
          isError={isError}
          isFetched={isFetched}
        >
          <div className="flex flex-row p-2">
            <button
              className={clsx('btn btn-group btn-lg', {
                'btn-group--active': listingType === 'BUY',
              })}
              onClick={() => setListingType('BUY')}
            >
              {t('buy')}
            </button>
            <button
              className={clsx('btn btn-group btn-lg', {
                'btn-group--active': listingType === 'RENT',
              })}
              onClick={() => setListingType('RENT')}
            >
              {t('rent')}
            </button>
          </div>
        </SimilarListing>
      </div>
    </>
  );
};

export default HousePricesSimilarListing;
